import { DialogModule } from '@angular/cdk/dialog';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { TextFieldModule } from '@angular/cdk/text-field';
import { NgModule } from '@angular/core';
import { PalantirAttachmentsDialogService } from './stories/attachments-dialog/attachments-dialog.service';
import { PalantirConfirmDialogComponent } from './stories/confirm-dialog/confirm-dialog.component';
import { PalantirConfirmDialogService } from './stories/confirm-dialog/confirm-dialog.service';
import { PalantirDialogRef } from './stories/dialog/dialog-ref.service';
import { PalantirDialogService } from './stories/dialog/dialog.service';
import { PalantirFilterModalService } from './stories/filter-modal/filter-modal.service';
import { PalantirModalRef } from './stories/modal/modal-ref.service';
import { PalantirModalService } from './stories/modal/modal.service';
import { PalantirSelectItemDialogComponent } from './stories/select-item-dialog/select-item-dialog.component';
import { PalantirSelectItemDialogService } from './stories/select-item-dialog/select-item-dialog.service';

@NgModule({
  exports: [DialogModule],
  imports: [
    DialogModule,
    TextFieldModule,
    PalantirConfirmDialogComponent,
    PalantirSelectItemDialogComponent,
    CdkStepperModule,
  ],
  providers: [
    PalantirModalService,
    PalantirDialogService,
    PalantirDialogRef,
    PalantirModalRef,
    PalantirConfirmDialogService,
    PalantirAttachmentsDialogService,
    PalantirSelectItemDialogService,
    PalantirFilterModalService,
  ],
})
export class PalantirModule {}
